import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EventTemplatesListRefreshService {
  private _refreshVersion = signal(0);

  refreshVersion() {
    return this._refreshVersion();
  }

  requestRefresh(): void {
    this._refreshVersion.update((version) => version + 1);
  }
}
